import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

export const PREVIOUS_SHIFT_SLOTS_COUNT = 5

export const TIMEZONE_GROUP_OPTIONS: AppSelectOption<string>[] = [
  { value: 'PACIFIC', text: 'Pacific' },
  { value: 'CENTRAL', text: 'Central' },
  { value: 'MOUNTAIN', text: 'Mountain' },
  { value: 'EASTERN', text: 'Eastern' },
  { value: 'OTHER', text: 'Other' },
]
